import {useCan} from '@/shared/hooks/use-permissions'
import {requirePermission} from '@/modules/auth/permissions'
import {useGetInfiniteActiveSubstanceDrugs} from '@/modules/drug-catalog/substances/api'
import {ActiveSubstancesFilters, ActiveSubstancesTable} from '@/modules/drug-catalog/substances/components'
import {ActiveSubstancesSearchSchema} from '@/modules/drug-catalog/substances/schemas'
import {ResourcesIndexPageHeader} from '@/shared/components/ui/resources-index-page-header'
import {createFileRoute} from '@tanstack/react-router'
import {ResourcesIndexPageTable} from '@/shared/components/ui/resources-index-page-table'

export const Route = createFileRoute('/configuration/drug-catalog/active-substances/')({
  beforeLoad: requirePermission('catalogue.view'),
  component: ActiveSubstancesPage,
  validateSearch: ActiveSubstancesSearchSchema,
})

const LIMIT = 50

function ActiveSubstancesPage() {
  const canManageCatalogue = useCan('catalogue.manage')
  const search = Route.useSearch()
  const [sort] = search.sort

  const infinite = useGetInfiniteActiveSubstanceDrugs({
    limit: LIMIT,
    sort: {
      dir: sort?.desc ? 'desc' : 'asc',
      field: sort?.id || 'createdAt',
    },
    filters: {
      status: [],
      calculationMethod: search.filters?.calculationMethod,
      categories: search.filters?.categories,
      unit: search.filters?.unit,
      search: search.filters?.search,
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infinite

  return (
    <>
      <ResourcesIndexPageHeader
        {...(canManageCatalogue ? {addNewTo: '/configuration/drug-catalog/active-substances/new'} : {})}
      >
        <ActiveSubstancesFilters />
      </ResourcesIndexPageHeader>

      <ResourcesIndexPageTable>
        <ActiveSubstancesTable
          virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
          table={{state: {sorting: search.sort}}}
        />
      </ResourcesIndexPageTable>
    </>
  )
}
